import { Outlet } from 'react-router-dom';
import { Sidebar } from '../../components_dashboard/Sidebar';

export function ClinicalSimLayout() {
  return (
    <div className="h-screen flex flex-col overflow-hidden bg-slate-50 text-slate-900 font-sans">
      <Sidebar />
      <main className="lg:ml-60 flex-1 overflow-y-auto min-h-0 relative">
        <Outlet />
      </main>
    </div>
  );
}
